/* eslint-disable import/prefer-default-export */

export const formatPrice = value => (value ? `${value < 0 ? '-' : ''}$${Math.abs(value).toFixed(2)}` : '$0.00');
export const formatPercent = (value, places) => {
  const placesValue = places !== null ? places : 0;
  return (value ? `${value.toFixed(placesValue)}%` : '0%');
};
